var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSizeSmall = function SvgSizeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v100H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 15h78v10H11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    d: "M16 18h68v4H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    fillOpacity: 0.5,
    d: "M11 30h78v10H11zM11 45h78v10H11zM11 60h78v10H11zM11 75h78v10H11z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5DAE3",
    d: "M16 33h68v4H16zM16 48h68v4H16zM16 63h68v4H16zM16 78h68v4H16z"
  })));
};
export { SvgSizeSmall as ReactComponent };
export default __webpack_public_path__ + "img/size-small.a5d05a2ee3e32860022505a82baa2841.svg";